export const readFile = async (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (e) => {
      resolve(<string>e.target?.result ?? '') // base64 string
    }

    reader.onerror = reject

    reader.readAsDataURL(file)
  })
